import React from 'react';
import { Handle, Position } from 'reactflow';
import './TriggerEmailNode.css';

const TriggerEmailNode = ({ data, isConnectable, selected }) => {
    // Simplified trigger - only Flow Start for email flows
    const triggerInfo = { icon: '🚀', color: '#10b981' };

    return (
        <div className={`email-trigger-node ${selected ? 'selected' : ''}`} style={{ '--node-color': triggerInfo.color }}>
            <div className="email-node-header trigger">
                <span className="email-node-icon">{triggerInfo.icon}</span>
                <span className="email-node-type">TRIGGER</span>
            </div>
            
            <div className="email-node-content">
                <h4>{data.label || 'Flow Start'}</h4>
                <p className="email-node-description">
                    Triggered externally from Product Flows or other systems
                </p>
            </div>

            <Handle
                type="source"
                position={Position.Right}
                id="trigger-output"
                isConnectable={isConnectable}
                className="email-handle email-handle-output"
            />
        </div>
    );
};

export default TriggerEmailNode;
